import rebrandText from "@cvpartner/design-system/logos/mainWordmark.svg";
import rebrandLogo from "@cvpartner/design-system/logos/royalBlueIcon.svg";
import { mediaQuery } from "@cvpartner/design-system/vars";
import classNames from "clsx";
import type * as React from "react";
import { useProgressBar } from "react-aria";
import { useMediaLayout } from "use-media";
import { useReadOrSaveInProgress } from "@/shared/queries/networkState.ts";
import {
  compactImage,
  compactLogo,
  logo,
  logoIcon,
  spinner,
} from "./Logo.css.ts";

type Size = "default" | "compact";

const Loader: React.FC<{ loading: boolean; size: Size }> = ({
  loading,
  size,
}) => {
  const { progressBarProps } = useProgressBar({
    isIndeterminate: true,
    "aria-label": "Loading",
  });

  if (!loading) {
    return <span className={spinner({ loading: false, size })} />;
  }

  return (
    <span {...progressBarProps} className={spinner({ loading: true, size })} />
  );
};

export const Logo: React.FC<{ size?: Size }> = ({ size = "default" }) => {
  const loading = useReadOrSaveInProgress();
  const showLogoText = useMediaLayout(mediaQuery.m);
  const imageClassName = size === "compact" ? compactImage : undefined;

  return (
    <a
      href="/dashboard"
      className={classNames(logo, size === "compact" && compactLogo)}
    >
      <img
        className={classNames(logoIcon({ loading }), imageClassName)}
        src={rebrandLogo}
        alt="Flowcase logo"
        aria-hidden={true}
      />
      <Loader loading={loading} size={size} />
      {showLogoText && (
        <img className={imageClassName} src={rebrandText} alt="Flowcase" />
      )}
    </a>
  );
};
